import { Box, Slider } from '@mui/material';

const CustomSlider = ({ reproduciendo, listadoImagenes, posicion, setPosicion, fechaMuestra }) => {

    return (
        <Box
            sx={{
                width: "50%",
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
                flexWrap: "wrap"
            }}
        >

            <Slider
                aria-label="Temperature"
                disabled={reproduciendo === 1}
                value={listadoImagenes.length - posicion}
                getAriaValueText={(value) => value}
                valueLabelDisplay='auto'
                onChange={(e) => setPosicion(listadoImagenes.length - e.target.value)}
                step={1}
                marks
                valueLabelFormat={fechaMuestra}
                min={1}
                max={listadoImagenes.length}
            />
            <p>Fecha:  {fechaMuestra}</p>
        </Box>
    )
}

export default CustomSlider
